export class PathHelper {
    public static get currentPath(): string {
        const timestamp = window._CVT_BUILD_TIMESTAMP;
        if (timestamp == null) {
            return location.origin;
        }
        return `${location.origin}/dist-${timestamp}`;
    }

    public static relativePath(path: string): string {
        if (!path.includes("../")) {
            return path.includes("./") ? `${PathHelper.currentPath}/${path.replace("./", "")}` : path[0] === '/' ? `${this.currentPath}${path}` : `${this.currentPath}/${path}`;
        }
        let splittedPath = PathHelper.currentPath.split("/");
        while (path.includes("../")) {
            splittedPath.pop();
            path = path.replace("../", "");
        }
        return `${splittedPath.join("/")}/${path}`;
    }
}